import { ChannelProvider } from 'ably/react';
import { jsx as _jsx } from "react/jsx-runtime";
const withAblyChannel = WrappedComponent => props => /*#__PURE__*/_jsx(ChannelProvider, {
  channelName: props.channelName,
  children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
});
export default withAblyChannel;